import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const objectValidator = ({ object, requiredError, invalidError, }) => z.object(object.shape, {
    error: createErrorHandler(requiredError, invalidError),
});
